import { Card, IconTile } from "@peer-start/ui";
import { GraduationCap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { domainBreakdown, domainQuestionTotal } from "../data/manager-domains.js";
import { DomainDonut } from "./DomainDonut.js";

const plumStrengths = [100, 74, 54, 36, 22] as const;

const plumShade = (index: number) =>
  `color-mix(in srgb, var(--primary) ${plumStrengths[index % plumStrengths.length]}%, var(--background))`;

export function ManagerDomainBreakdown() {
  const { t, i18n } = useTranslation();
  const domains = domainBreakdown();
  const count = new Intl.NumberFormat(i18n.language);

  return (
    <Card
      aria-labelledby="manager-domains-title"
      className="h-full"
      data-control-id="manager.dashboard.domains"
      padding="compact"
    >
      <div className="flex items-center gap-4">
        <IconTile>
          <GraduationCap className="size-5" />
        </IconTile>
        <h2 className="text-base font-medium" id="manager-domains-title">
          {t("managerDashboard.domains.title")}
        </h2>
      </div>
      <div className="mt-4">
        <DomainDonut
          centerLabel={t("managerDashboard.domains.centerLabel")}
          centerValue={count.format(domainQuestionTotal())}
          description={t("managerDashboard.domains.chartLabel", {
            domains: domains
              .map(
                (domain) =>
                  `${domain.title} ${t("managerDashboard.usage.percent", { value: domain.share })}, ${t("managerDashboard.domains.questions", { count: domain.questions })}`,
              )
              .join(". "),
          })}
          segments={domains.map((domain, index) => ({
            id: domain.id,
            share: domain.share,
            color: plumShade(index),
            title: domain.title,
            percent: t("managerDashboard.usage.percent", { value: domain.share }),
            detail: t("managerDashboard.domains.questions", { count: domain.questions }),
          }))}
        />
      </div>
    </Card>
  );
}
